import { Description, TextInput } from "ui";
import { z } from "zod";
import { BlockEditorForm } from "../../BlockEditorForm";

const ImageBlockSchema = z.object({
  alt: z.string(),
  url: z.string(),
  caption: z.string(),
});

type ImageBlockData = z.infer<typeof ImageBlockSchema>;

interface Props extends ImageBlockData {
  onUpdate: (data: Partial<ImageBlockData>) => void;
  onClose: () => void;
}

export function Editor({ alt, url, caption, onUpdate, onClose }: Props) {
  const defaultValues: ImageBlockData = {
    alt,
    url,
    caption,
  };

  const handleSubmit = async (data: ImageBlockData) => {
    onUpdate(data);
  };

  return (
    <BlockEditorForm<ImageBlockData>
      schema={ImageBlockSchema}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      onClose={onClose}
    >
      <TextInput name="alt" label="Alt Text" placeholder="Description of the image" />
      <Description>Used by screen readers and when images fail to load</Description>

      <TextInput name="url" label="Link URL" placeholder="https://example.com" />
      <Description>Make the image clickable to open a link</Description>

      <TextInput name="caption" label="Caption" placeholder="Image caption" />
    </BlockEditorForm>
  );
}
